import { PaginatedTableSearch } from './PaginatedTableSearch';
export default PaginatedTableSearch;
